module.exports = new __parcel__URL__("DACI Hover.c4a9d2d6.svg").toString();